module.exports = __webpack_public_path__ + "static/media/Maestro.9e8a229b.svg";